import { render } from "./ResultComponent.vue?vue&type=template&id=3519e6d5&scoped=true"
import script from "./ResultComponent.vue?vue&type=script&lang=js"
export * from "./ResultComponent.vue?vue&type=script&lang=js"

import "./ResultComponent.vue?vue&type=style&index=0&id=3519e6d5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3519e6d5"]])

export default __exports__